export const getCEP = (cep) => {
  return fetch("https://viacep.com.br/ws/" + cep + "/json/", {
    method: "GET",
  }).then((request) => request.json().then((data) => data));
};
